// extracted by mini-css-extract-plugin
export var featureContainer = "index-module--featureContainer--MAA1z";
export var featureImage = "index-module--featureImage--aWlAv";